import React from 'react';
import { UserProductGroup } from '~/Api/User/ProductGroup';
import { selectCardinalPlural } from '~/utils/Intl';
import ProductGroupAddForm from '~/ProductGroupAddForm';
import { ServiceContext } from '~/ServiceContext';

import { ActionPanel, Props as ActionPanelProps } from '~/UI/ActionPanel/ActionPanel';

type Props = ActionPanelProps & {
	onProductsCopied?: () => void;
};

const CopyGroupProductActionPanel: React.FC<React.PropsWithChildren<Props>> = (props) => {
	const { copyGroupProductManager } = React.useContext(ServiceContext);
	const { products, selectedProductsCount, onProductsCopied } = props;

	const handleSave = React.useCallback(
		(group: UserProductGroup) => {
			copyGroupProductManager
				.copyProductGroup(group, products, {
					flashMessageText: `${selectedProductsCount} ${selectCardinalPlural(selectedProductsCount, [
						'drug',
						'drugs',
					])} copied to list `,
				})
				.then(() => {
					onProductsCopied?.();
				});
		},
		[copyGroupProductManager, products, selectedProductsCount, onProductsCopied]
	);

	return (
		<ActionPanel {...props}>
			<ProductGroupAddForm productsCount={props.selectedProductsCount} onSave={handleSave} />
		</ActionPanel>
	);
};

CopyGroupProductActionPanel.displayName = 'CopyGroupProduct.CopyGroupProductActionPanel';

export default React.memo(CopyGroupProductActionPanel);
